// import { useNavigate, useLocation } from "react-router-dom";
// import { useState, useRef, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { toggle } from "../Store/Slices/AuthSlice";

// const ROW_HEIGHT = "h-14";
// const isMobile = window.innerWidth < 768;

// const SidebarShadow = ({ menuItems, onItemClick }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [openMenu, setOpenMenu] = useState(null);
//   const [showContact, setShowContact] = useState(false);
//   const contactRef = useRef(null);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const handler = (e) => {
//       if (contactRef.current && !contactRef.current.contains(e.target)) {
//         setShowContact(false);
//       }
//     };

//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <div className="h-full pt-6 relative">
//       {menuItems?.map((item) => {
//         const active = item.view && location.pathname === `/${item.view}`;
//         const isOpen = openMenu === item.title;

//         return (
//           <div key={item.title} className="mb-1 relative">
//             {/* ===== MAIN ITEM ===== */}
//             <button
//               // onClick={() => {
//               //   if (item.links) {
//               //     setOpenMenu(isOpen ? null : item.title);
//               //     return;
//               //   }

//               //   if (item.action === "contact") {
//               //     setShowContact((prev) => !prev);
//               //     return;
//               //   }

//               //   if (!item.view) return;
//               //   navigate(`/${item.view}`);
//               //   onItemClick?.();
//               // }}
//               onClick={() => {
//                 if (item.links) {
//                   setOpenMenu(isOpen ? null : item.title);
//                   return;
//                 }

//                 if (item.view) {
//                   navigate(`/${item.view}`);

//                   // ✅ Only mobile pe close
//                   if (isMobile) {
//                     dispatch(toggle());
//                   }
//                 }
//               }}
//               className={`
//                 ${ROW_HEIGHT}
//                 w-full flex items-center
//                 px-6 rounded-xl
//                 transition-all duration-200
//                 ${active
//                   ? "bg-white text-indigo-700 font-semibold shadow-sm"
//                   : "text-slate-700 hover:bg-slate-100 hover:text-indigo-700"
//                 }
//               `}
//             >
//               <span className="text-sm">{item.title}</span>

//               {item.links && (
//                 <span
//                   className={`ml-auto transition-transform duration-200
//                     ${isOpen ? "rotate-90 text-indigo-600" : "text-slate-400"}
//                   `}
//                 >
//                   ▶
//                 </span>
//               )}
//             </button>

//             {/* ===== CONTACT POPUP ===== */}
//             {/* {item.action === "contact" && showContact && (
//               <div
//                 ref={contactRef}
//                 className="
//                   absolute left-full top-1/2 -translate-y-1/2 ml-4
//                   bg-white rounded-2xl shadow-xl
//                   border border-slate-200
//                   w-64 z-[200]
//                 "
//               >
                
//                 <div
//                   className="
//                     absolute left-[-6px] top-1/2 -translate-y-1/2
//                     w-3 h-3 bg-white rotate-45
//                     border-l border-b border-slate-200
//                   "
//                 />

//                 <div className="p-4 space-y-3">
//                   <p className="text-xs uppercase tracking-wide text-slate-500">
//                     Contact Support
//                   </p>

//                   <div className="flex items-center gap-3 text-sm">
//                     <Phone size={16} className="text-indigo-600" />
//                     <span>+91 98765 43210</span>
//                   </div>

//                   <div className="flex items-center gap-3 text-sm">
//                     <Mail size={16} className="text-indigo-600" />
//                     <span>support@yourdomain.com</span>
//                   </div>
//                 </div>
//               </div>
//             )} */}

//             {/* ===== SUBMENU ===== */}
//             {item.links && isOpen && (
//               <div className="ml-6 mt-1 space-y-1">
//                 {item.links.map((link) => {
//                   const childActive =
//                     location.pathname === `/${link.view}`;

//                   return (
//                     <button
//                       key={link.name}
//                       onClick={() => {
//                         navigate(`/${link.view}`);
//                         setOpenMenu(null);

//                         // ✅ Only mobile pe close
//                         if (isMobile) {
//                           dispatch(toggle());
//                         }
//                       }}
//                       className={`
//                         w-full flex items-center
//                         px-4 py-2 rounded-lg text-sm
//                         transition-all
//                         ${childActive
//                           ? "bg-indigo-100 text-indigo-700 font-semibold"
//                           : "text-slate-600 hover:bg-slate-100 hover:text-indigo-700"
//                         }
//                       `}
//                     >
//                       {link.name}
//                     </button>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default SidebarShadow;


// import { useNavigate, useLocation } from "react-router-dom";
// import { useState, useRef, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { toggle } from "../Store/Slices/AuthSlice";
// import { ChevronRight } from "lucide-react";

// const ROW_HEIGHT = "h-14";
// const isMobile = window.innerWidth < 768;

// const SidebarShadow = ({ menuItems, onItemClick }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const od = useSelector((s) => s.auth.employeeDetails?.od) === true;

//   console.log("dhbcdjbjdbd", od)
//   const visibleItems = (menuItems ?? []).filter((item) => {
//     if (item.view === "oddashboard") return od;
//     return true;
//   });

//   console.log("schbjbjcdjcd", visibleItems)

//   const [openMenu, setOpenMenu] = useState(null);
//   const [showContact, setShowContact] = useState(false);
//   const contactRef = useRef(null);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const handler = (e) => {
//       if (contactRef.current && !contactRef.current.contains(e.target)) {
//         setShowContact(false);
//       }
//     };

//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <div className="h-full pt-6 relative bg-[#0A2A4F] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
//       {visibleItems.map((item) => {
//         const active = item.view && location.pathname === `/${item.view}`;
//         const isOpen = openMenu === item.title;

//         return (
//           <div key={item.title} className="mb-1 relative">

//             {/* ===== MAIN ITEM ===== */}
//             <button
//               onClick={() => {
//                 if (item.links) {
//                   setOpenMenu(isOpen ? null : item.title);
//                   return;
//                 }

//                 if (item.view) {
//                   navigate(`/${item.view}`);
//                   if (isMobile) {
//                     dispatch(toggle());
//                   }
//                 }
//               }}
//               className={`
//                 ${ROW_HEIGHT}
//                 w-full flex items-center gap-3
//                 px-5 rounded-xl
//                 transition-all duration-300 relative overflow-hidden

//                 ${active
//                   ? "bg-white text-[#0A2A4F] font-semibold shadow-md"
//                   : "text-white/90"
//                 }

//                 hover:bg-white/90 hover:text-[#0A2A4F]
//                 hover:backdrop-blur-md hover:shadow-lg
//               `}
//             >

//               {/* 🔥 LEFT ACTIVE BORDER */}
//               {active && (
//                 <span className="absolute left-0 top-0 h-full w-[4px] bg-indigo-600 rounded-r-md"></span>
//               )}

//               {/* 🔥 ICON */}
//               <span className={`
//                 transition-transform duration-300
//                 ${active ? "scale-110" : "group-hover:scale-105"}
//               `}>
//                 {item.icon || "•"}
//               </span>

//               {/* TEXT */}
//               <span className="text-sm tracking-wide">
//                 {item.title}
//               </span>

//               {/* ARROW */}
//               {item.links && (
//                 <ChevronRight
//                   size={16}
//                   className={`ml-auto transition-all duration-300
//                     ${isOpen ? "rotate-90 text-[#0A2A4F]" : "text-white/70"}
//                   `}
//                 />
//               )}
//             </button>

//             {/* ===== SUBMENU ===== */}
//             {item.links && isOpen && (
//               <div className="ml-5 mt-1 space-y-1 border-l border-white/20 pl-3">
//                 {item.links.map((link) => {
//                   const childActive =
//                     location.pathname === `/${link.view}`;

//                   return (
//                     <button
//                       key={link.name}
//                       onClick={() => {
//                         navigate(`/${link.view}`);
//                         setOpenMenu(null);

//                         if (isMobile) {
//                           dispatch(toggle());
//                         }
//                       }}
//                       className={`
//                         w-full flex items-center gap-2
//                         px-4 py-2 rounded-lg text-sm
//                         transition-all duration-300 relative

//                         ${childActive
//                           ? "bg-white text-[#0A2A4F] font-semibold shadow"
//                           : "text-white/80"
//                         }

//                         hover:bg-white/90 hover:text-[#0A2A4F]
//                         hover:shadow-md hover:backdrop-blur-md
//                       `}
//                     >
//                       {/* Dot indicator */}
//                       <span className={`
//                         w-2 h-2 rounded-full
//                         ${childActive ? "bg-indigo-600" : "bg-white/50"}
//                       `}></span>

//                       {link.name}
//                     </button>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default SidebarShadow;



// new ui 
import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggle } from "../Store/Slices/AuthSlice";
import { ChevronRight } from "lucide-react";

const isMobile = window.innerWidth < 768;

const SidebarShadow = ({ menuItems, onItemClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const od = useSelector((s) => s.auth.employeeDetails?.od) === true;
  const username = useSelector((s) => s.auth?.employeeDetails?.username);
  const role = useSelector((s) => s.auth?.employeeDetails?.role);
  const hideAepsLedger = username === "sou4276_2330" && role === "MERCHANT";

  const visibleItems = (menuItems ?? [])
    .map((item) => {
      if (item.links) {
        const filteredLinks = hideAepsLedger
          ? item.links.filter((link) => link.view !== "aepsledger" && link.view !== "ratelist")
          : item.links;
        return { ...item, links: filteredLinks };
      }
      return item;
    })
    .filter((item) => {
      if (item.view === "oddashboard") return od;
      if (hideAepsLedger && (item.view === "aepsledger" || item.view === "ratelist")) return false;
      if (item.links && item.links.length === 0) return false;
      return true;
    });

  const [openMenu, setOpenMenu] = useState(null);
  const [showContact, setShowContact] = useState(false);
  const contactRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (contactRef.current && !contactRef.current.contains(e.target)) {
        setShowContact(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="h-full py-4 px-3 bg-gradient-to-b from-[#0A2540] via-[#0F3057] to-[#0A2540] border-r border-white/10 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] flex flex-col justify-between">
      <div className="space-y-1.5">
        {visibleItems.map((item) => {
          const active = item.view && location.pathname === `/${item.view}`;
          const isParentOfActiveChild = item.links?.some(
            (link) => location.pathname === `/${link.view}`
          );
          const isOpen = openMenu === item.title;

          return (
            <div key={item.title} className="relative">
              {/* ===== MAIN NAVIGATION ITEM ===== */}
              <button
                onClick={() => {
                  if (item.links) {
                    setOpenMenu(isOpen ? null : item.title);
                    return;
                  }

                  if (item.view) {
                    navigate(`/${item.view}`);
                    if (onItemClick) onItemClick(item);
                    if (isMobile) {
                      dispatch(toggle());
                    }
                  }
                }}
                className={`
                  group w-full h-11 flex items-center justify-between
                  px-3.5 rounded-xl text-xs font-semibold
                  transition-all duration-200 select-none relative
                  ${
                    active
                      ? "bg-white text-slate-900 shadow-md shadow-black/10 font-bold"
                      : isParentOfActiveChild
                      ? "bg-white/10 text-white border border-white/15"
                      : "text-slate-300 hover:text-white hover:bg-white/10"
                  }
                `}
              >
                <div className="flex items-center gap-3 min-w-0">
                  {/* Icon Capsule */}
                  <div
                    className={`
                      w-7 h-7 rounded-lg flex items-center justify-center text-sm transition-transform duration-200
                      ${
                        active
                          ? "bg-blue-600 text-white shadow-xs"
                          : "bg-white/10 text-slate-300 group-hover:text-white group-hover:bg-white/20"
                      }
                    `}
                  >
                    {item.icon || "•"}
                  </div>

                  {/* Title */}
                  <span className="truncate tracking-wide">{item.title}</span>
                </div>

                {/* Submenu Indicator Arrow */}
                {item.links && (
                  <ChevronRight
                    size={14}
                    className={`shrink-0 transition-transform duration-200 ${
                      isOpen
                        ? "rotate-90 text-white"
                        : active
                        ? "text-slate-900"
                        : "text-slate-400 group-hover:text-white"
                    }`}
                  />
                )}
              </button>

              {/* ===== SUBMENU ACCORDION ===== */}
              {item.links && isOpen && (
                <div className="mt-1 ml-4 pl-3.5 border-l border-white/15 space-y-1 animate-in fade-in slide-in-from-top-1 duration-150">
                  {item.links.map((link) => {
                    const childActive = location.pathname === `/${link.view}`;

                    return (
                      <button
                        key={link.name}
                        onClick={() => {
                          navigate(`/${link.view}`);
                          setOpenMenu(null);
                          if (onItemClick) onItemClick(link);
                          if (isMobile) {
                            dispatch(toggle());
                          }
                        }}
                        className={`
                          w-full h-9 flex items-center gap-2.5
                          px-3 rounded-lg text-xs font-medium
                          transition-all duration-150 relative
                          ${
                            childActive
                              ? "bg-white/20 text-white font-semibold shadow-xs border border-white/20"
                              : "text-slate-400 hover:text-white hover:bg-white/10"
                          }
                        `}
                      >
                        {/* Status Dot */}
                        <span
                          className={`
                            w-1.5 h-1.5 rounded-full transition-all
                            ${childActive ? "bg-sky-400 scale-125" : "bg-white/40"}
                          `}
                        />

                        <span className="truncate">{link.name}</span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SidebarShadow;